export const updateLoanDataRequestResponse = {
  _id: "67f44f69e685b472c479f7dd",
  createDateTime: "2025-04-07T22:19:21.651000",
  updateDateTime: "2025-10-06T18:26:09.274000",
  lastViewDateTime: "2025-10-15T17:57:33.130000",
  pipeline: "Underwriting",
  loanNumber: 1005,
  loanName: "125 Carley Ave, Huntington, NY 11743 (Jimmy Test Loan Updated)",
  isTableFunding: false,
  isBalanceSheetClosing: false,
  loanStatus: "Inactive",
  milestoneStatusChanges: [
    {
      priorMilestoneStatus: "Appraisal Ordered",
      milestoneChangeDate: "2025-04-07T22:24:34.927000",
      updatedMilestoneStatus: "Appraisal In",
      updateBy: "joliva@cliffcomortgage.com",
      form_types: {
        priorMilestoneStatus: "string",
        milestoneChangeDate: "dateTime",
        updatedMilestoneStatus: "string",
        updateBy: "email",
      },
    },
    {
      priorMilestoneStatus: "Appraisal In",
      milestoneChangeDate: "2025-08-05T15:28:36.674000",
      updatedMilestoneStatus: "Inactive",
      updateBy: "joliva@cliffcomortgage.com",
      form_types: {
        priorMilestoneStatus: "string",
        milestoneChangeDate: "dateTime",
        updatedMilestoneStatus: "string",
        updateBy: "email",
      },
    },
    {
      priorMilestoneStatus: "Inactive",
      milestoneChangeDate: "2025-08-14T14:33:28.714000",
      updatedMilestoneStatus: "Closed w/ Post Closing Conditions",
      updateBy: "joliva@cliffcomortgage.com",
      form_types: {
        priorMilestoneStatus: "string",
        milestoneChangeDate: "dateTime",
        updatedMilestoneStatus: "string",
        updateBy: "email",
      },
    },
    {
      priorMilestoneStatus: "Closed w/ Post Closing Conditions",
      milestoneChangeDate: "2025-08-14T14:33:43.251000",
      updatedMilestoneStatus: "Inactive",
      updateBy: "joliva@cliffcomortgage.com",
      form_types: {
        priorMilestoneStatus: "string",
        milestoneChangeDate: "dateTime",
        updatedMilestoneStatus: "string",
        updateBy: "email",
      },
    },
    {
      priorMilestoneStatus: "Inactive",
      milestoneChangeDate: "2025-08-14T18:40:06.769000",
      updatedMilestoneStatus: "Dead",
      updateBy: "joliva@cliffcomortgage.com",
      form_types: {
        priorMilestoneStatus: "string",
        milestoneChangeDate: "dateTime",
        updatedMilestoneStatus: "string",
        updateBy: "email",
      },
    },
    {
      priorMilestoneStatus: "Dead",
      milestoneChangeDate: "2025-08-14T18:58:52.631000",
      updatedMilestoneStatus: "Closed w/ Post Closing Conditions",
      updateBy: "joliva@cliffcomortgage.com",
      form_types: {
        priorMilestoneStatus: "string",
        milestoneChangeDate: "dateTime",
        updatedMilestoneStatus: "string",
        updateBy: "email",
      },
    },
    {
      priorMilestoneStatus: "Closed w/ Post Closing Conditions",
      milestoneChangeDate: "2025-08-14T18:59:04.098000",
      updatedMilestoneStatus: "Prospect",
      updateBy: "joliva@cliffcomortgage.com",
      form_types: {
        priorMilestoneStatus: "string",
        milestoneChangeDate: "dateTime",
        updatedMilestoneStatus: "string",
        updateBy: "email",
      },
    },
    {
      priorMilestoneStatus: "Prospect",
      milestoneChangeDate: "2025-08-14T18:59:13.108000",
      updatedMilestoneStatus: "Processing",
      updateBy: "joliva@cliffcomortgage.com",
      form_types: {
        priorMilestoneStatus: "string",
        milestoneChangeDate: "dateTime",
        updatedMilestoneStatus: "string",
        updateBy: "email",
      },
    },
    {
      priorMilestoneStatus: "Processing",
      milestoneChangeDate: "2025-08-20T15:02:32.137000",
      updatedMilestoneStatus: "Inactive",
      updateBy: "joliva@cliffcomortgage.com",
      form_types: {
        priorMilestoneStatus: "string",
        milestoneChangeDate: "dateTime",
        updatedMilestoneStatus: "string",
        updateBy: "email",
      },
    },
  ],
  loanProductType: "Fix and Flip",
  loanPurpose: "Refinance - No Cash Out",
  salesperson: "joliva@cliffcomortgage.com",
  processor: "cwolpert@cliffcomortgage.com",
  permittedUsers: ["joliva@cliffcomortgage.com"],
  baseLoanAmount: 985000,
  totalHoldback: 25000,
  dutchInterest: false,
  loanDocuments: [
    {
      _id: "68da9bef9c0656e40667b68c",
      isFinal: false,
      documentStatus: "Initial Reviewed",
      parsed: "False",
      searchIndexed: "False",
      containerName: "67f44f69e685b472c479f7dd",
      docGroup: "Borrower Documents",
      docType: "Loan Application",
      file_name_as_loaded: "image.png",
      file_display_name: "pete credit auth.png",
      file_storage_name: "2e176ec4-9d43-11f0-aec0-eeb3c207b7ec.png",
      content_type: "image/png",
      size: 204846,
      uploadedBy: "joliva@cliffcomortgage.com",
      uploadDate: "2025-09-29T14:47:11.014178",
      modifiedDate: "2025-10-06T16:21:15",
      dealId: "67f44f69e685b472c479f7dd",
      updatedBy: "joliva@cliffcomortgage.com",
      container_type: null,
      name: "image.png",
      file_extension: "png",
    },
    {
      _id: "68d70aeaf5762dc2a0685688",
      isFinal: false,
      documentStatus: "New Upload",
      parsed: "False",
      searchIndexed: "False",
      containerName: "67f44f69e685b472c479f7dd",
      docGroup: "Appraisal",
      docType: "Appraisal - Other",
      file_name_as_loaded: "image.png",
      file_display_name: "lindor document.png",
      file_storage_name: "fade7d30-9b22-11f0-a1ef-2ee97ab3d84f.png",
      content_type: "image/png",
      size: 61941,
      uploadedBy: "joliva@cliffcomortgage.com",
      uploadDate: "2025-09-26T21:51:38.856193",
      modifiedDate: "2025-10-07T17:51:30",
      dealId: "67f44f69e685b472c479f7dd",
      updatedBy: "dev1@cliffcomortgage.com",
      container_type: null,
      reportEffectiveDate: "2024-10-01T04:00:00.000Z",
      name: "image.png",
      reportGuidelineExpirationDays: "90",
      file_extension: "png",
    },
    {
      _id: "68d70856a6935b71e14f5d1d",
      isFinal: false,
      documentStatus: "New Upload",
      parsed: "False",
      searchIndexed: "False",
      containerName: "67f44f69e685b472c479f7dd",
      docGroup: "Appraisal",
      docType: "Appraisal - Other",
      file_name_as_loaded: "image.png",
      file_display_name: "lindor credit report.png",
      file_storage_name: "715d96dc-9b21-11f0-a5f3-b625f6c56b2b.png",
      content_type: "image/png",
      size: 61941,
      uploadedBy: "joliva@cliffcomortgage.com",
      uploadDate: "2025-09-26T21:40:38.666777",
      modifiedDate: "2025-10-06T16:21:15",
      dealId: "67f44f69e685b472c479f7dd",
      updatedBy: "joliva@cliffcomortgage.com",
      container_type: null,
      name: "image.png",
      file_extension: "png",
    },
    {
      _id: "68d7000f9fa129b7173876c3",
      isFinal: false,
      documentStatus: "New Upload",
      parsed: "False",
      searchIndexed: "False",
      containerName: "67f44f69e685b472c479f7dd",
      file_name_as_loaded: "image.png",
      file_display_name: "checklist comment.png",
      file_storage_name: "821a9498-9b1c-11f0-8409-de184e02c3d4.png",
      content_type: "image/png",
      size: 30535,
      uploadedBy: "joliva@cliffcomortgage.com",
      uploadDate: "2025-09-26T21:05:19.265405",
      modifiedDate: "2025-09-26T21:05:19",
      dealId: "67f44f69e685b472c479f7dd",
      name: "image.png",
      file_extension: "png",
    },
    {
      _id: "68cdb1b7b8ad9225fe2b09a8",
      isFinal: false,
      documentStatus: "New Upload",
      parsed: false,
      searchIndexed: false,
      containerName: "67f44f69e685b472c479f7dd",
      file_name_as_loaded: "image.png",
      file_display_name: "image.png",
      file_storage_name: "856c0668-9590-11f0-bee9-66e2ebf73669.png",
      content_type: "image/png",
      size: 16208,
      uploadedBy: "joliva@cliffcomortgage.com",
      uploadDate: "2025-09-19T19:40:39.476305",
      modifiedDate: "2025-09-23T17:09:58",
      dealId: "67f44f69e685b472c479f7dd",
      updatedBy: "joliva@cliffcomortgage.com",
      container_type: null,
      name: "image.png",
      file_extension: "png",
    },
    {
      _id: "68cb1e8f8cc193ee4bb4b7d0",
      isFinal: false,
      documentStatus: "Initial Reviewed",
      parsed: false,
      searchIndexed: false,
      containerName: "67f44f69e685b472c479f7dd",
      docGroup: "Appraisal",
      docType: "Appraisal PDF",
      file_name_as_loaded: "loans_pipeline.xlsx",
      file_display_name: "appraisal.xlsx",
      file_storage_name: "a20d3aa6-9407-11f0-b3ed-ea38d8e9e628.xlsx",
      content_type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      size: 6727,
      uploadedBy: "dev1@cliffcomortgage.com",
      uploadDate: "2025-09-17T20:48:15.294238",
      modifiedDate: "2025-10-01T15:37:57",
      dealId: "67f44f69e685b472c479f7dd",
      updatedBy: "dev1@cliffcomortgage.com",
      container_type: null,
      reportEffectiveDate: "2025-09-30T04:00:00.000Z",
      name: "loans_pipeline.xlsx",
      reportGuidelineExpirationDays: "120",
      file_extension: "xlsx",
    },
    {
      _id: "68c9b7add585bafcf84efee9",
      isFinal: false,
      documentStatus: "New Upload",
      parsed: false,
      searchIndexed: false,
      containerName: "67f44f69e685b472c479f7dd",
      docGroup: "Parsed Document Outputs",
      file_name_as_loaded: "image.png",
      file_display_name: "pipeline image.png",
      file_storage_name: "b9193eba-9331-11f0-a223-1632e49047af.png",
      content_type: "image/png",
      size: 738218,
      uploadedBy: "joliva@cliffcomortgage.com",
      uploadDate: "2025-09-16T19:17:01.660382",
      modifiedDate: "2025-09-23T17:48:31",
      dealId: "67f44f69e685b472c479f7dd",
      updatedBy: "joliva@cliffcomortgage.com",
      container_type: null,
      name: "image.png",
      file_extension: "png",
    },
    {
      _id: "68c9b009d585bafcf84efdfd",
      isFinal: false,
      documentStatus: "Initial Reviewed",
      parsed: false,
      searchIndexed: false,
      containerName: "67f44f69e685b472c479f7dd",
      docGroup: "Parsed Document Outputs",
      file_name_as_loaded: "salesforce2.svg",
      file_display_name: "logo.svg",
      file_storage_name: "2b5ce486-932d-11f0-a223-1632e49047af.svg",
      content_type: "image/svg+xml",
      size: 8594,
      uploadedBy: "joliva@cliffcomortgage.com",
      uploadDate: "2025-09-16T18:44:25.880339",
      modifiedDate: "2025-09-25T19:20:30",
      dealId: "67f44f69e685b472c479f7dd",
      updatedBy: "joliva@cliffcomortgage.com",
      container_type: null,
      name: "salesforce-2.svg",
      file_extension: "svg",
    },
    {
      _id: "68c9aa0cd585bafcf84efd2d",
      isFinal: false,
      documentStatus: "Initial Reviewed",
      parsed: false,
      searchIndexed: false,
      containerName: "67f44f69e685b472c479f7dd",
      docGroup: "Parsed Document Outputs",
      file_name_as_loaded: "image.png",
      file_display_name: "copypaste111.png",
      file_storage_name: "9997850e-9329-11f0-a223-1632e49047af.png",
      content_type: "image/png",
      size: 329060,
      uploadedBy: "joliva@cliffcomortgage.com",
      uploadDate: "2025-09-16T18:18:52.827050",
      modifiedDate: "2025-09-25T19:20:30",
      dealId: "67f44f69e685b472c479f7dd",
      updatedBy: "joliva@cliffcomortgage.com",
      container_type: null,
      name: "image.png",
      file_extension: "png",
    },
    {
      _id: "68c98ca8d585bafcf84efbce",
      isFinal: false,
      documentStatus: "Initial Reviewed",
      parsed: false,
      searchIndexed: false,
      containerName: "67f44f69e685b472c479f7dd",
      docGroup: "Parsed Document Outputs",
      file_name_as_loaded: "image.png",
      file_display_name: "copypastecommenttest.png",
      file_storage_name: "14fe980c-9318-11f0-a223-1632e49047af.png",
      content_type: "image/png",
      size: 440175,
      uploadedBy: "joliva@cliffcomortgage.com",
      uploadDate: "2025-09-16T16:13:28.921175",
      modifiedDate: "2025-09-25T19:20:30",
      dealId: "67f44f69e685b472c479f7dd",
      updatedBy: "joliva@cliffcomortgage.com",
      container_type: null,
      name: "image.png",
      file_extension: "png",
    },
    {
      _id: "68c866671f809d6ec88de9de",
      isFinal: false,
      documentStatus: "Initial Reviewed",
      parsed: false,
      searchIndexed: false,
      containerName: "67f44f69e685b472c479f7dd",
      docGroup: "Borrower Documents",
      file_name_as_loaded: "image.png",
      file_display_name: "copypastecommenttest.png",
      file_storage_name: "b10b5c90-9268-11f0-9fd8-423292c7d38b.png",
      content_type: "image/png",
      size: 563802,
      uploadedBy: "joliva@cliffcomortgage.com",
      uploadDate: "2025-09-15T19:17:59.305024",
      modifiedDate: "2025-09-30T13:59:20",
      dealId: "67f44f69e685b472c479f7dd",
      updatedBy: "joliva@cliffcomortgage.com",
      container_type: null,
      name: "image.png",
      file_extension: "png",
    },
    {
      _id: "68c859b31f809d6ec88de91d",
      isFinal: false,
      documentStatus: "Initial Reviewed",
      parsed: false,
      searchIndexed: false,
      containerName: "67f44f69e685b472c479f7dd",
      docGroup: "Parsed Document Outputs",
      file_name_as_loaded: "image.png",
      file_display_name: "filefromcopypastecomment.png",
      file_storage_name: "1f04c23e-9261-11f0-9fd8-423292c7d38b.png",
      content_type: "image/png",
      size: 384614,
      uploadedBy: "joliva@cliffcomortgage.com",
      uploadDate: "2025-09-15T18:23:47.837290",
      modifiedDate: "2025-09-25T19:20:30",
      dealId: "67f44f69e685b472c479f7dd",
      updatedBy: "joliva@cliffcomortgage.com",
      container_type: null,
      name: "image.png",
      file_extension: "png",
    },
    {
      _id: "68c465677fe4d088446b64c9",
      isFinal: false,
      documentStatus: "New Upload",
      parsed: false,
      searchIndexed: false,
      containerName: "67f44f69e685b472c479f7dd",
      file_name_as_loaded: "image.png",
      file_display_name: "image.png",
      file_storage_name: "be8f14b6-9005-11f0-8b0d-b264738638ad.png",
      content_type: "image/png",
      size: 742780,
      uploadedBy: "joliva@cliffcomortgage.com",
      uploadDate: "2025-09-12T18:24:39.476836",
      modifiedDate: "2025-09-23T17:09:58",
      dealId: "67f44f69e685b472c479f7dd",
      updatedBy: "joliva@cliffcomortgage.com",
      container_type: null,
      name: "image.png",
      file_extension: "png",
    },
    {
      _id: "68c450257fe4d088446b63a0",
      isFinal: false,
      documentStatus: "New Upload",
      parsed: false,
      searchIndexed: false,
      containerName: "67f44f69e685b472c479f7dd",
      file_name_as_loaded: "image.png",
      file_display_name: "image.png",
      file_storage_name: "12b9f680-8ff9-11f0-8b0d-b264738638ad.png",
      content_type: "image/png",
      size: 99268,
      uploadedBy: "joliva@cliffcomortgage.com",
      uploadDate: "2025-09-12T16:53:57.228970",
      modifiedDate: "2025-09-23T17:09:58",
      dealId: "67f44f69e685b472c479f7dd",
      updatedBy: "joliva@cliffcomortgage.com",
      container_type: null,
      name: "image.png",
      file_extension: "png",
    },
    {
      _id: "68c4361f7fe4d088446b629a",
      isFinal: false,
      documentStatus: "New Upload",
      parsed: false,
      searchIndexed: false,
      containerName: "67f44f69e685b472c479f7dd",
      file_name_as_loaded: "image.png",
      file_display_name: "this was a copy paste image.png",
      file_storage_name: "8feac2ac-8fe9-11f0-8b0d-b264738638ad.png",
      content_type: "image/png",
      size: 47918,
      uploadedBy: "joliva@cliffcomortgage.com",
      uploadDate: "2025-09-12T15:02:55.316330",
      modifiedDate: "2025-09-23T17:09:58",
      dealId: "67f44f69e685b472c479f7dd",
      updatedBy: "joliva@cliffcomortgage.com",
      container_type: null,
      name: "image.png",
      file_extension: "png",
    },
    {
      _id: "68a6253f982207f5ea3d8097",
      isHidden: true,
      isFinal: false,
      documentStatus: "New Upload",
      parsed: false,
      searchIndexed: false,
      containerName: "67f44f69e685b472c479f7dd",
      docGroup: "Entity Docs",
      docType: "Amended Entity Document",
      file_name_as_loaded: "download 7.jpg",
      file_display_name: "Amended Change Test.jpg",
      file_storage_name: "de027f96-7dfd-11f0-abf7-b66065063426.jpg",
      content_type: "image/jpeg",
      size: 206993,
      uploadedBy: "joliva@cliffcomortgage.com",
      uploadDate: "2025-08-20T19:42:55.338781",
      modifiedDate: "2025-10-01T17:41:38",
      dealId: "67f44f69e685b472c479f7dd",
      updatedBy: "joliva@cliffcomortgage.com",
      container_type: null,
      reportEffectiveDate: "2024-08-01T04:00:00.000Z",
      name: "download (7).jpg",
      reportGuidelineExpirationDays: "90",
      file_extension: "jpg",
    },
    {
      _id: "688a8411a4b87d5c039a2d7d",
      isHidden: true,
      isFinal: false,
      documentStatus: "New Upload",
      parsed: false,
      searchIndexed: false,
      containerName: "67f44f69e685b472c479f7dd",
      docGroup: "Entity Docs",
      docType: "EIN",
      file_name_as_loaded: "SampleJPGImage_500kbmb 1.jpg",
      file_display_name: "time test.jpg",
      file_storage_name: "ec458fb8-6d85-11f0-b7ec-c680901b4009.jpg",
      content_type: "image/jpeg",
      size: 512017,
      uploadedBy: "joliva@cliffcomortgage.com",
      uploadDate: "2025-07-30T20:44:01.054409",
      modifiedDate: "2025-08-20T18:35:40",
      dealId: "67f44f69e685b472c479f7dd",
      updatedBy: "joliva@cliffcomortgage.com",
      container_type: null,
      name: "SampleJPGImage_500kbmb (1).jpg",
      file_extension: "jpg",
    },
    {
      _id: "6879619b311b0d44a63be7e1",
      isFinal: false,
      documentStatus: "New Upload",
      parsed: false,
      searchIndexed: false,
      containerName: "67f44f69e685b472c479f7dd",
      docGroup: "Entity Docs",
      docType: "EIN",
      file_name_as_loaded: "Loan Applications  71025 2.xlsx",
      file_display_name: "Loan Applications  71025 2.xlsx",
      file_storage_name: "63e8071c-634f-11f0-94cf-da652af7f77f.xlsx",
      content_type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      size: 6664,
      uploadedBy: "joliva@cliffcomortgage.com",
      uploadDate: "2025-07-17T20:48:27.820126",
      modifiedDate: "2025-09-23T17:48:31",
      dealId: "67f44f69e685b472c479f7dd",
      updatedBy: "joliva@cliffcomortgage.com",
      container_type: null,
      name: "Loan Applications - 7-10-25 (2).xlsx",
      file_extension: "xlsx",
    },
    {
      _id: "6879617e311b0d44a63be7d2",
      isHidden: true,
      isFinal: false,
      documentStatus: "Expired",
      parsed: false,
      searchIndexed: false,
      containerName: "67f44f69e685b472c479f7dd",
      docGroup: "Appraisal",
      docType: "Appraisal Invoice",
      file_name_as_loaded: "Appraisal Example 1.pdf",
      file_display_name: "appraisal amendment 2 change2.pdf",
      file_storage_name: "52a9f00a-634f-11f0-94cf-da652af7f77f.pdf",
      content_type: "application/pdf",
      size: 5195548,
      uploadedBy: "joliva@cliffcomortgage.com",
      uploadDate: "2025-07-17T20:47:58.891956",
      modifiedDate: "2025-10-01T17:39:11",
      dealId: "67f44f69e685b472c479f7dd",
      updatedBy: "joliva@cliffcomortgage.com",
      container_type: null,
      name: "Appraisal Example (1).pdf",
      file_extension: "pdf",
    },
    {
      _id: "6879617e311b0d44a63be7d0",
      isFinal: false,
      documentStatus: "Accepted",
      parsed: false,
      searchIndexed: false,
      containerName: "67f44f69e685b472c479f7dd",
      docGroup: "Appraisal",
      docType: "Appraisal Amendment",
      file_name_as_loaded: "exampleloanapp.pdf",
      file_display_name: "lindor loan app.pdf",
      file_storage_name: "52926c0a-634f-11f0-94cf-da652af7f77f.pdf",
      content_type: "application/pdf",
      size: 68933,
      uploadedBy: "joliva@cliffcomortgage.com",
      uploadDate: "2025-07-17T20:47:58.737825",
      modifiedDate: "2025-10-06T16:21:15",
      dealId: "67f44f69e685b472c479f7dd",
      updatedBy: "joliva@cliffcomortgage.com",
      container_type: null,
      name: "example-loan-app.pdf",
      file_extension: "pdf",
    },
    {
      _id: "687806067f5e13776e015d90",
      isFinal: false,
      documentStatus: "Accepted",
      parsed: false,
      searchIndexed: false,
      containerName: "67f44f69e685b472c479f7dd",
      docGroup: "Borrower Documents",
      docType: "Background Report",
      file_name_as_loaded: "NICKIE_GREEN_credit_report.pdf",
      file_display_name: "NICKIE_GREEN_credit_report.pdf",
      file_storage_name: "36d94e0e-6280-11f0-bad4-1aab0750d7bf.pdf",
      content_type: "application/pdf",
      size: 175792,
      uploadedBy: "joliva@cliffcomortgage.com",
      uploadDate: "2025-07-16T20:05:26.403135",
      modifiedDate: "2025-09-23T12:58:19",
      dealId: "67f44f69e685b472c479f7dd",
      updatedBy: "joliva@cliffcomortgage.com",
      container_type: null,
      name: "NICKIE_GREEN_credit_report.pdf",
      file_extension: "pdf",
    },
    {
      _id: "687806067f5e13776e015d8e",
      isFinal: false,
      documentStatus: "Accepted",
      parsed: false,
      searchIndexed: false,
      containerName: "67f44f69e685b472c479f7dd",
      docGroup: "Borrower Documents",
      docType: "Background Report",
      file_name_as_loaded: "NICKIE_GREEN_credit_report 1.pdf",
      file_display_name: "NICKIE_GREEN_credit_report 1.pdf",
      file_storage_name: "36cd617a-6280-11f0-bad4-1aab0750d7bf.pdf",
      content_type: "application/pdf",
      size: 175792,
      uploadedBy: "joliva@cliffcomortgage.com",
      uploadDate: "2025-07-16T20:05:26.324968",
      modifiedDate: "2025-09-23T12:58:19",
      dealId: "67f44f69e685b472c479f7dd",
      updatedBy: "joliva@cliffcomortgage.com",
      container_type: null,
      name: "NICKIE_GREEN_credit_report (1).pdf",
      file_extension: "pdf",
    },
    {
      _id: "681b8d3e2543436fced7e2cf",
      isFinal: false,
      documentStatus: "Initial Reviewed",
      parsed: false,
      searchIndexed: false,
      containerName: "67f44f69e685b472c479f7dd",
      docGroup: "Closing Package",
      docType: "CEMA",
      file_name_as_loaded: "Bridge EV RTL Guidelines_v4.0.pdf",
      file_display_name: "pete bank statement.pdf",
      file_storage_name: "23406468-2b62-11f0-b289-72767ac00e60.pdf",
      content_type: "application/pdf",
      size: 1144572,
      uploadedBy: "dev1@cliffcomortgage.com",
      uploadDate: "2025-05-07T16:41:34.669638",
      modifiedDate: "2025-10-06T16:21:15",
      dealId: "67f44f69e685b472c479f7dd",
      updatedBy: "joliva@cliffcomortgage.com",
      container_type: null,
      name: "Bridge EV RTL Guidelines_v4.0.pdf",
      file_extension: "pdf",
    },
    {
      _id: "681b8d3e2543436fced7e2cd",
      isFinal: false,
      documentStatus: "Initial Reviewed",
      parsed: false,
      searchIndexed: false,
      containerName: "67f44f69e685b472c479f7dd",
      docGroup: "Questionnaires",
      docType: "Condo Questionnaire",
      file_name_as_loaded: "Eastview RTL Guidelines_v4.1.pdf",
      file_display_name: "Questionnaire.pdf",
      file_storage_name: "23354420-2b62-11f0-b289-72767ac00e60.pdf",
      content_type: "application/pdf",
      size: 344412,
      uploadedBy: "dev1@cliffcomortgage.com",
      uploadDate: "2025-05-07T16:41:34.596713",
      modifiedDate: "2025-09-25T19:20:30",
      dealId: "67f44f69e685b472c479f7dd",
      updatedBy: "joliva@cliffcomortgage.com",
      container_type: null,
      name: "Eastview RTL Guidelines_v4.1.pdf",
      file_extension: "pdf",
    },
    {
      _id: "681b8d262543436fced7e2c4",
      isFinal: false,
      documentStatus: "Initial Reviewed",
      parsed: false,
      searchIndexed: false,
      containerName: "67f44f69e685b472c479f7dd",
      docGroup: "Entity Docs",
      docType: "EIN",
      file_name_as_loaded: "Eastview RTL Guidelines_v4.1.pdf",
      file_display_name: "Eastview RTL Guidelines_v4.1.pdf",
      file_storage_name: "14e19b6c-2b62-11f0-b289-72767ac00e60.pdf",
      content_type: "application/pdf",
      size: 344412,
      uploadedBy: "dev1@cliffcomortgage.com",
      uploadDate: "2025-05-07T16:41:10.560345",
      modifiedDate: "2025-09-23T17:48:31",
      dealId: "67f44f69e685b472c479f7dd",
      updatedBy: "joliva@cliffcomortgage.com",
      container_type: null,
      name: "Eastview RTL Guidelines_v4.1.pdf",
      file_extension: "pdf",
    },
    {
      _id: "680902cf22626709077ca0b6",
      isFinal: false,
      documentStatus: "Initial Reviewed",
      parsed: false,
      searchIndexed: false,
      containerName: "67f44f69e685b472c479f7dd",
      docGroup: "Terms & Sizer",
      docType: "Sizer",
      file_name_as_loaded: "Quick Intake Loan Template.xlsx",
      file_display_name: "Latest sizer.xlsx",
      file_storage_name: "0afaf80e-2055-11f0-a89f-9e94c2c9dffa.xlsx",
      content_type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      size: 35554,
      uploadedBy: "dev1@cliffcomortgage.com",
      uploadDate: "2025-04-23T15:10:07.701331",
      modifiedDate: "2025-09-25T19:20:30",
      dealId: "67f44f69e685b472c479f7dd",
      updatedBy: "joliva@cliffcomortgage.com",
      container_type: null,
      name: "Quick Intake Loan Template.xlsx",
      file_extension: "xlsx",
    },
    {
      _id: "680902cf22626709077ca0b4",
      isFinal: false,
      documentStatus: "Initial Reviewed",
      parsed: false,
      searchIndexed: false,
      containerName: "67f44f69e685b472c479f7dd",
      docGroup: "Borrower Documents",
      docType: "Background Report",
      file_name_as_loaded: "2144 Insurance 1.pdf",
      file_display_name: "pete loan app.pdf",
      file_storage_name: "0af34f0a-2055-11f0-a89f-9e94c2c9dffa.pdf",
      content_type: "application/pdf",
      size: 155579,
      uploadedBy: "dev1@cliffcomortgage.com",
      uploadDate: "2025-04-23T15:10:07.651094",
      modifiedDate: "2025-10-06T16:21:15",
      dealId: "67f44f69e685b472c479f7dd",
      updatedBy: "joliva@cliffcomortgage.com",
      container_type: null,
      name: "2144 Insurance (1).pdf",
      file_extension: "pdf",
    },
    {
      _id: "67fe7ae3b1a091224ecb41ec",
      isFinal: false,
      documentStatus: "Initial Reviewed",
      parsed: false,
      searchIndexed: false,
      containerName: "67f44f69e685b472c479f7dd",
      docGroup: "Insurance Docs",
      docType: "Insurance Invoice",
      file_name_as_loaded: "Closing package 3.pdf",
      file_display_name: "Closing package 3.pdf",
      file_storage_name: "25a395be-1a0e-11f0-92e3-52a93937c40c.pdf",
      content_type: "application/pdf",
      size: 5195548,
      uploadedBy: "joliva@cliffcomortgage.com",
      uploadDate: "2025-04-15T15:27:31.182659",
      modifiedDate: "2025-09-23T17:48:31",
      dealId: "67f44f69e685b472c479f7dd",
      updatedBy: "joliva@cliffcomortgage.com",
      container_type: null,
      name: "Closing package (3).pdf",
      file_extension: "pdf",
    },
    {
      _id: "67fe7ae3b1a091224ecb41ea",
      isFinal: false,
      documentStatus: "New Upload",
      parsed: false,
      searchIndexed: false,
      containerName: "67f44f69e685b472c479f7dd",
      docGroup: "Insurance Docs",
      docType: "Insurance Invoice",
      file_name_as_loaded: "uw_model_fields.xlsx",
      file_display_name: "uw_model_fields.xlsx",
      file_storage_name: "259652c8-1a0e-11f0-92e3-52a93937c40c.xlsx",
      content_type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      size: 33327,
      uploadedBy: "joliva@cliffcomortgage.com",
      uploadDate: "2025-04-15T15:27:31.095693",
      modifiedDate: "2025-09-23T17:48:31",
      dealId: "67f44f69e685b472c479f7dd",
      updatedBy: "joliva@cliffcomortgage.com",
      container_type: null,
      name: "uw_model_fields.xlsx",
      file_extension: "xlsx",
    },
    {
      _id: "67f45108e685b472c479f7e2",
      isFinal: false,
      documentStatus: "Rejected",
      parsed: false,
      searchIndexed: false,
      containerName: "67f44f69e685b472c479f7dd",
      docGroup: "Entity Docs",
      docType: "Corporate Resolution",
      file_name_as_loaded: "download 6.jpg",
      file_display_name: "Example background report.jpg",
      file_storage_name: "5219cd80-13ff-11f0-bf81-3aeb6936811d.jpg",
      content_type: "image/jpeg",
      size: 206993,
      uploadedBy: "joliva@cliffcomortgage.com",
      uploadDate: "2025-04-07T22:26:16.349549",
      modifiedDate: "2025-09-23T17:48:31",
      dealId: "67f44f69e685b472c479f7dd",
      updatedBy: "joliva@cliffcomortgage.com",
      container_type: null,
      name: "download (6).jpg",
      file_extension: "jpg",
    },
    {
      _id: "67f45108e685b472c479f7e0",
      isHidden: true,
      isFinal: false,
      documentStatus: "New Upload",
      parsed: false,
      searchIndexed: false,
      containerName: "67f44f69e685b472c479f7dd",
      docGroup: "Entity Docs",
      docType: "Corporate Resolution",
      file_name_as_loaded: "SampleJPGImage_500kbmb 1.jpg",
      file_display_name: "SampleJPGImage_500kbmb 1.jpg",
      file_storage_name: "520aaf30-13ff-11f0-bf81-3aeb6936811d.jpg",
      content_type: "image/jpeg",
      size: 512017,
      uploadedBy: "joliva@cliffcomortgage.com",
      uploadDate: "2025-04-07T22:26:16.250451",
      modifiedDate: "2025-08-20T18:35:40",
      dealId: "67f44f69e685b472c479f7dd",
      updatedBy: "joliva@cliffcomortgage.com",
      container_type: null,
      name: "SampleJPGImage_500kbmb (1).jpg",
      file_extension: "jpg",
    },
  ],
  subjectProperties: [
    {
      _id: "67f44f69e685b472c479f7de",
      address: {
        fullAddress: "125 Carley Ave, Huntington, NY 11743",
        latitude: 40.866112,
        longitude: -73.43475,
        address_object: {
          id: "A-1yb5xFhzjCuSufdQxVXQ-1752188978403",
          fullAddress: "125 Carley Avenue, Huntington, NY 11743",
          county: "NY",
          country: "United States",
          countryCode: "US",
          latitude: 40.866112,
          longitude: -73.43475,
          coordinateTuple: [40.866112, -73.43475],
          score: 1,
        },
        streetAddress: "",
      },
      propertyType: "3-unit",
      proposedPropertyType: "4-unit",
      propertyRuralIndicator: true,
      floodZone: false,
      scopeOfWork: [],
      units: [
        {
          _id: "68cb181b8cc193ee4bb4b6f1",
          unitNumber: "1011abc",
          leaseType: "12-Month Lease - Occupied",
          leaseStartDate: "2025-09-01T04:00:00",
          leaseEndDate: "2026-09-01T04:00:00",
          unitSquareFootage: 1200,
          unitMonthlyInPlaceRent: 2600,
          unitMonthlyMarketRent: 3000,
          unitVacant: false,
          residentialUnit: true,
          commercialUnit: false,
          unitNotes: "This is a good place to live",
        },
      ],
      costBasis: 0,
      secondaryAsIsVariance: 0,
      secondaryArvVariance: 0,
      unitCount: 1,
      vacantUnitCount: 0,
      residentialUnitCount: 1,
      commercialUnitCount: 0,
      monthlyTaxes: 0,
      monthlyInsurance: 0,
      monthlyFloodInsurance: 0,
      monthlyHoaFees: 0,
      monthlyPropertyMgmtFees: 0,
      monthlyOtherExpense: 0,
      squareFootageChange: 0,
    },
  ],
  borrowers: [
    {
      _id: "68a61f68982207f5ea3d8018",
      firstName: "Francisco",
      lastName: "Lindor",
      phoneNumber: "5555555556",
      emailAddress: "frank@mets.com",
      createDateTime: "2025-08-08T22:52:19.017000",
      signUpDate: "2025-08-08T22:52:19.017000",
      ficoLow: 0,
      ficoMid: 0,
      ficoMax: 0,
      otherLiquidity: 0,
      cashLiquidity: 0,
      borrowerSSN: "555555555",
      primaryAddress: {
        fullAddress: "12301 Roosevelt Avenue, Corona, NY 11368",
        streetName: "Roosevelt Avenue",
        streetNumber: "12301",
        zip: "11368",
        county: "NY",
        state: "New York",
        city: "New York",
        country: "United States",
        latitude: 40.7574856,
        longitude: -73.8448408,
        id: "7lRavyOEKzbhqf5igXQuYw-1755717455204",
        countryCode: "US",
        coordinateTuple: [40.7574856, -73.8448408],
        score: 0.9816489516453671,
        streetAddress: "12301 Roosevelt Avenue",
      },
      entityPercentOwnership: 0.65,
      isGuarantor: true,
      isPrimaryContactForLoan: false,
      maritalStatus: "Married",
      firstTimeHomebuyer: false,
      hasExperienceWithIncomeProducingProperties: false,
      hasExperienceWithFixFlips: false,
      hasExperienceWithGroundUpConstruction: false,
      ff_sold: {
        less_than_three_years: 0,
        greater_than_three_years: 0,
      },
      ff_retained_as_rental: {
        less_than_three_years: 0,
        greater_than_three_years: 0,
      },
      income_producing_properties: {
        less_than_three_years: 0,
        greater_than_three_years: 0,
      },
      guc_sold: {
        less_than_three_years: 0,
        greater_than_three_years: 0,
      },
      guc_retained_as_rental: {
        less_than_three_years: 0,
        greater_than_three_years: 0,
      },
      general_contractor_projects: {
        less_than_three_years: 0,
        greater_than_three_years: 0,
      },
      citizenshipStatus: "US Citizen",
      dateOfBirth: "1998-08-11T04:00:00",
      verifiedLiquidity: 0,
      verifiedExperienceTotal: 0,
      borrowerGuidelineChecks: [],
      foreignNationalFlag: false,
      borrowerHasSSN: true,
      application_felony_conviction: false,
      application_financial_fraud_misdemeanor: false,
      bankruptcy_flag: false,
      open_liens_judgments: false,
      profileComplete: true,
      email_lower: "frank@mets.com",
      email_domain: "mets.com",
      totalLiquidity: 0,
      associations: {
        loanDocuments: ["68d70aeaf5762dc2a0685688", "68d70856a6935b71e14f5d1d"],
        subjectProperties: ["67f44f69e685b472c479f7de"],
      },
    },
    {
      _id: "67f44f69e685b472c479f7df",
      firstName: "Pete",
      lastName: "Alonso",
      createDateTime: "2025-10-06T17:51:22.346226",
      signUpDate: "2025-10-06T17:51:22.346278",
      ficoLow: 0,
      ficoMid: 0,
      ficoMax: 0,
      otherLiquidity: 0,
      cashLiquidity: 0,
      entityPercentOwnership: 0.35,
      isGuarantor: true,
      isPrimaryContactForLoan: false,
      firstTimeHomebuyer: false,
      hasExperienceWithIncomeProducingProperties: false,
      hasExperienceWithFixFlips: false,
      hasExperienceWithGroundUpConstruction: false,
      ff_sold: {
        less_than_three_years: 2,
      },
      income_producing_properties: {
        less_than_three_years: 1,
      },
      verifiedLiquidity: 0,
      verifiedExperienceTotal: 0,
      borrowerGuidelineChecks: [],
      profileComplete: false,
      totalLiquidity: 0,
      foreignNationalFlag: false,
    },
  ],
  updateHistory: [],
  borrowerEntity: {
    _id: "68efe16f4e79a360968c1167",
    entityName: "Example Entity Company",
    entityMembers: [],
  },
  termMonths: 0,
  interestOnlyMonths: 0,
  expectedClosingDate: "2025-12-02T00:00:00+00:00",
  referralSource: "Test Referrer",
  interestRate: 0.09626,
  discountPoints: 0.005,
  originationPoints: 0.01,
  floatingRateLoanRateIndex: "SOFR",
  closingAsEntity: true,
  amortizationType: "Interest Only",
  interestCalcType: "Actual/360",
  outstandingLoanUpb: 760000,
  existingLoanInDefault: false,
  prepaymentPenaltyMonths: 36,
  prepaymentPenaltyStructure: "4% 3% 2% 1%",
  comments: [
    {
      _id: "68cdb1b7b8ad9225fe2b09ab",
      htmlString: "<p>association change</p>\n",
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-09-19T19:40:39.534000",
      mentions: [],
      associations: {
        loanDocuments: ["68cb1e8f8cc193ee4bb4b7d0"],
        borrowers: ["68a61f68982207f5ea3d8018"],
        subjectProperties: ["67f44f69e685b472c479f7de"],
        applications: null,
        creditAuthorizations: null,
        conditions: null,
        taskListItems: null,
        managementExceptions: null,
        comments: null,
      },
      submittedBy: "joliva@cliffcomortgage.com",
    },
    {
      _id: "68cd9c198cc193ee4bb4cc87",
      htmlString: "<p>Ammend</p>\n",
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-09-19T18:08:25.660000",
      mentions: [],
      associations: {
        loanDocuments: ["68a6253f982207f5ea3d8097"],
        borrowers: [],
        subjectProperties: [],
      },
      submittedBy: "joliva@cliffcomortgage.com",
    },
    {
      _id: "68cb1e8f8cc193ee4bb4b7d3",
      htmlString: "<p>Francisco Bank statement</p>\n",
      postedBy: "dev1@cliffcomortgage.com",
      commentDateTime: "2025-09-17T20:48:15.507000",
      mentions: [],
      associations: {
        loanDocuments: ["6879617e311b0d44a63be7d0", "68cb1e8f8cc193ee4bb4b7d0"],
        borrowers: ["68a61f68982207f5ea3d8018"],
        subjectProperties: ["67f44f69e685b472c479f7de"],
      },
      submittedBy: "dev1@cliffcomortgage.com",
    },
    {
      _id: "68c9c792d585bafcf84f00ad",
      htmlString: "<p>Pete Alonso comment</p>\n",
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-09-16T20:24:50.449000",
      mentions: [],
      associations: {
        loanDocuments: [],
        borrowers: ["67f44f69e685b472c479f7df"],
        subjectProperties: [],
      },
      submittedBy: "joliva@cliffcomortgage.com",
    },
    {
      _id: "68c9b7add585bafcf84efeec",
      htmlString: "<p>Comment added with file from pipeline</p>\n",
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-09-16T19:17:01.819000",
      mentions: [],
      associations: {
        loanDocuments: ["68c9b7add585bafcf84efee9"],
        borrowers: [],
        subjectProperties: [],
      },
      submittedBy: "joliva@cliffcomortgage.com",
    },
    {
      _id: "68c9b01bd585bafcf84efe20",
      htmlString: "<p>commont on logo</p>\n",
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-09-16T18:44:43.109000",
      mentions: [],
      associations: {
        loanDocuments: ["68c9b009d585bafcf84efdfd"],
        borrowers: [],
        subjectProperties: [],
      },
      submittedBy: "joliva@cliffcomortgage.com",
    },
    {
      _id: "68c9b009d585bafcf84efe00",
      htmlString: "<p>Another nested comment with 4 tags</p>\n",
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-09-16T18:44:25.974000",
      mentions: [],
      associations: {
        loanDocuments: ["6879617e311b0d44a63be7d2", "68c9b009d585bafcf84efdfd"],
        borrowers: ["68a61f68982207f5ea3d8018"],
        subjectProperties: ["67f44f69e685b472c479f7de"],
      },
      submittedBy: "joliva@cliffcomortgage.com",
    },
    {
      _id: "68c9aa0cd585bafcf84efd30",
      htmlString:
        '<p>New nested commentObjects With Uploaded File Endpoint includes:</p>\n<ul>\n<li>Copy and paste image called "copypaste111"</li>\n<li>Tagged borrower "Alonso"</li>\n<li>Tagged property "125 Carley"</li>\n<li>Tagged existing file "Questionnaire.pdf"</li>\n</ul>\n',
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-09-16T18:18:52.928000",
      mentions: [],
      associations: {
        loanDocuments: ["681b8d3e2543436fced7e2cd", "68c9aa0cd585bafcf84efd2d"],
        borrowers: ["67f44f69e685b472c479f7df"],
        subjectProperties: ["67f44f69e685b472c479f7de"],
      },
      submittedBy: "joliva@cliffcomortgage.com",
    },
    {
      _id: "68c9a307d585bafcf84efc53",
      htmlString: "<p>Comment with nested commentObjects</p>\n",
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-09-16T17:48:55.229000",
      mentions: [],
      associations: {
        loanDocuments: [],
        borrowers: ["68a61f68982207f5ea3d8018"],
        subjectProperties: ["67f44f69e685b472c479f7de"],
        documents: ["68c866671f809d6ec88de9de", "68c859b31f809d6ec88de91d"],
      },
      submittedBy: "joliva@cliffcomortgage.com",
    },
    {
      _id: "68c98ca9d585bafcf84efbd1",
      htmlString:
        '<p>New Comment Endpoint includes:</p>\n<ul>\n<li>Copy and paste image called "copy-paste-comment-test"</li>\n<li>Tagged borrower "Lindor"</li>\n<li>Tagged property "125 Carley"</li>\n<li>Tagged existing file "Questionnaire.pdf"</li>\n</ul>\n',
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-09-16T16:13:29.067000",
      mentions: [],
      associations: {
        loanDocuments: ["68c98ca8d585bafcf84efbce"],
      },
      borrowers: ["68a61f68982207f5ea3d8018"],
      subjectProperties: ["67f44f69e685b472c479f7de"],
      documents: ["681b8d3e2543436fced7e2cd"],
      submittedBy: "joliva@cliffcomortgage.com",
    },
    {
      _id: "68c4628c7fe4d088446b6453",
      htmlString: "<p>This is good</p>\n",
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-09-12T18:12:28.330000",
      mentions: [],
      borrowers: [],
      subjectProperties: [],
      documents: ["67f45108e685b472c479f7e2"],
      submittedBy: "joliva@cliffcomortgage.com",
    },
    {
      _id: "68c462787fe4d088446b643c",
      htmlString: "<p>Please review this borrowers file</p>\n",
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-09-12T18:12:08.294000",
      mentions: [],
      borrowers: ["68a61f68982207f5ea3d8018"],
      subjectProperties: [],
      documents: ["67f45108e685b472c479f7e2"],
      submittedBy: "joliva@cliffcomortgage.com",
    },
    {
      _id: "68c436727fe4d088446b62e7",
      htmlString: "<p>comment on this copy paste image</p>\n",
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-09-12T15:04:18.836000",
      mentions: [],
      borrowers: [],
      subjectProperties: [],
      documents: ["68c4361f7fe4d088446b629a"],
      submittedBy: "joliva@cliffcomortgage.com",
    },
    {
      _id: "68c3337cbc3777c997da3b7c",
      htmlString: "<p>Comment added from file test</p>\n",
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-09-11T20:39:24.817000",
      mentions: [],
      borrowers: [],
      subjectProperties: [],
      documents: ["68a6253f982207f5ea3d8097"],
      submittedBy: "joliva@cliffcomortgage.com",
    },
    {
      _id: "68c327e5bc3777c997da3a32",
      htmlString: "<p>Another comment on Amended file</p>\n",
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-09-11T19:49:57.011000",
      mentions: [],
      borrowers: [],
      subjectProperties: [],
      documents: ["68a6253f982207f5ea3d8097"],
      submittedBy: "joliva@cliffcomortgage.com",
    },
    {
      _id: "68c2def54985e61994d46eb0",
      htmlString: "<p>Comment with some tags</p>\n",
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-09-11T14:38:45.835000",
      mentions: [],
      borrowers: ["68a61f68982207f5ea3d8018"],
      subjectProperties: ["67f44f69e685b472c479f7de"],
      documents: ["68a6253f982207f5ea3d8097"],
      submittedBy: "joliva@cliffcomortgage.com",
    },
    {
      _id: "68c09d224985e61994d466dc",
      htmlString: "<p></p>\n",
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-09-09T21:33:22.172000",
      mentions: [],
      borrowers: ["68a61f68982207f5ea3d8018"],
      subjectProperties: ["67f44f69e685b472c479f7de"],
      documents: ["6879617e311b0d44a63be7d0"],
      uploadedFiles: [
        "upload_1757453077522_e5v3c3ahp",
        "upload_1757453094536_a80le16zi",
        "upload_1757453575318_4c7kckfmh",
        "upload_1757453576868_bdoqzp2wl",
        "upload_1757453577107_h92v6exsz",
        "upload_1757453577330_rsrrbougj",
      ],
      submittedBy: "joliva@cliffcomortgage.com",
    },
    {
      _id: "68c076a8013e3b49aacc7e9a",
      htmlString: "<p>Test comment</p>\n",
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-09-09T18:49:12.632000",
      mentions: [],
      submittedBy: "joliva@cliffcomortgage.com",
    },
    {
      _id: "68a5e369982207f5ea3d7dfb",
      htmlString:
        "<p>Hey sorry Christian you can disrgard this along with any other loan assigned to me name. I am using this loan for testing purposes, but can move the loan out of the scenario pipeline so that it does not interfere with anything&nbsp;</p>\n",
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-08-20T15:02:01.177000",
      mentions: [],
      submittedBy: "joliva@cliffcomortgage.com",
    },
    {
      _id: "68a5de66982207f5ea3d7d45",
      htmlString:
        "<p>Hi JImmy, do you need us to test anything with this?</p>\n",
      postedBy: "cnguyen@cliffcomortgage.com",
      commentDateTime: "2025-08-20T14:40:38.336000",
      mentions: [],
      submittedBy: "cnguyen@cliffcomortgage.com",
    },
    {
      _id: "689cd056982207f5ea3d381c",
      htmlString:
        '<p>Mention test with first name included <a href="Jimmy Oliva" class="wysiwyg-mention" data-mention data-value="joliva@cliffcomortgage.com">Jimmy Oliva &lt;joliva@cliffcomortgage.com&gt;</a>&nbsp;</p>\n',
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-08-13T17:50:14.370000",
      mentions: [
        {
          emailAddress: "joliva@cliffcomortgage.com",
          userName: "Jimmy Oliva",
          mentionedDateTime: "2025-08-13T17:50:14.370000",
        },
      ],
      submittedBy: "joliva@cliffcomortgage.com",
    },
    {
      _id: "689ccd90982207f5ea3d3809",
      htmlString:
        '<p>Test <a href="Jimmy Oliva" class="wysiwyg-mention" data-mention data-value="joliva@cliffcomortgage.com">Jimmy Oliva &lt;joliva@cliffcomortgage.com&gt;</a>  5 for mentions</p>\n',
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-08-13T17:38:24.638000",
      mentions: [
        {
          emailAddress: "joliva@cliffcomortgage.com",
          userName: "Jimmy Oliva",
          mentionedDateTime: "2025-08-13T17:38:24.638000",
        },
      ],
      submittedBy: "joliva@cliffcomortgage.com",
    },
    {
      _id: "689cc05b982207f5ea3d37b9",
      htmlString:
        '<p>New mention <a href="Jimmy Oliva" class="wysiwyg-mention" data-mention data-value="Jimmy Oliva <joliva@cliffcomortgage.com>">@Jimmy Oliva &lt;joliva@cliffcomortgage.com&gt;</a> test <a href="#4" class="wysiwyg-hashtag">#4</a></p>\n',
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-08-13T16:42:03.290000",
      mentions: [
        {
          userName: "Jimmy Oliva",
          mentionedDateTime: "2025-08-13T16:42:03.290000",
        },
      ],
      submittedBy: "joliva@cliffcomortgage.com",
    },
    {
      _id: "689cbbe5982207f5ea3d3796",
      htmlString:
        '<p>New mention test <a href="Jimmy Oliva" class="wysiwyg-mention" data-mention data-value="joliva@cliffcomortgage.com">@joliva@cliffcomortgage.com</a>&nbsp;</p>\n',
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-08-13T16:23:01.135000",
      mentions: [
        {
          emailAddress: "joliva@cliffcomortgage.com",
          userName: "Jimmy Oliva",
          mentionedDateTime: "2025-08-13T16:23:01.135000",
        },
      ],
      submittedBy: "joliva@cliffcomortgage.com",
    },
    {
      _id: "689cbad1982207f5ea3d3773",
      htmlString:
        '<p>Comment mention with old way <a href="Jimmy Oliva" class="wysiwyg-mention" data-mention data-value="joliva@cliffcomortgage.com">@joliva@cliffcomortgage.com</a>&nbsp;</p>\n',
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-08-13T16:18:25.145000",
      mentions: [
        {
          emailAddress: "joliva@cliffcomortgage.com",
          userName: "Jimmy Oliva",
          mentionedDateTime: "2025-08-13T16:18:25.145000",
        },
      ],
      submittedBy: "joliva@cliffcomortgage.com",
    },
    {
      _id: "689cba0d982207f5ea3d3750",
      htmlString:
        '<p>Comment with <a href="Jimmy Oliva" class="wysiwyg-mention" data-mention data-value="Jimmy Oliva <joliva@cliffcomortgage.com>">@Jimmy Oliva &lt;joliva@cliffcomortgage.com&gt;</a> updated name</p>\n',
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-08-13T16:15:09.467000",
      mentions: [
        {
          userName: "Jimmy Oliva",
          mentionedDateTime: "2025-08-13T16:15:09.467000",
        },
      ],
      submittedBy: "joliva@cliffcomortgage.com",
    },
    {
      _id: "68224d15adda683973a71411",
      htmlString:
        '<p><a href="Jimmy Oliva" class="wysiwyg-mention" data-mention data-value="joliva@cliffcomortgage.com">@joliva@cliffcomortgage.com</a> <a href="Chris Wolpert" class="wysiwyg-mention" data-mention data-value="cwolpert@cliffcomortgage.com">@cwolpert@cliffcomortgage.com</a>&nbsp;</p>\n',
      postedBy: "dev1@cliffcomortgage.com",
      commentDateTime: "2025-05-12T19:33:41.701000",
      mentions: [
        {
          emailAddress: "joliva@cliffcomortgage.com",
          userName: "Jimmy Oliva",
          mentionedDateTime: "2025-05-12T19:33:41.702000",
        },
        {
          emailAddress: "cwolpert@cliffcomortgage.com",
          userName: "Chris Wolpert",
          mentionedDateTime: "2025-05-12T19:33:41.702000",
        },
      ],
      submittedBy: "dev1@cliffcomortgage.com",
    },
    {
      _id: "67f4525d08ac25613fe53b1d",
      htmlString: "<p>Another comment example</p>\n",
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-04-07T22:31:57.933000",
      submittedBy: "joliva@cliffcomortgage.com",
    },
    {
      _id: "67f451a908ac25613fe53b13",
      htmlString: "<p>Newest comment example</p>\n",
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-04-07T22:28:57.012000",
      submittedBy: "joliva@cliffcomortgage.com",
    },
  ],
  applications: [
    "67cb27dd2fdd9fd6b7d446d6",
    "67cb28482fdd9fd6b7d446e0",
    "67cb366b58fc76ffd4d53630",
  ],
  exceptions: [
    {
      _id: "68dc2307ba8a52da99fa60c3",
      dealId: null,
      exceptionCategory: "Borrower",
      exceptionDescription: "Example of a submitted hard exception updated",
      exceptionStatus: "In Review",
      riskBucket: "Borrower Profile",
      assignedTo: "joliva@cliffcomortgage.com",
      resolutionConditions: null,
      resolutionComments: null,
      createDateTime: null,
      dueDateTime: "2025-09-16T04:00:00",
      comments: null,
      sendEmail: true,
      sendTeamsMessage: false,
      resolutionDateTime: null,
      resolvedBy: null,
      updateDateTime: "2025-09-30T14:45:07.389000",
      associations: null,
      taskListItemId: null,
      isHardException: true,
      description: null,
      notifyDealCannotProceedAsStructured: true,
      notifyDealDead: false,
      compensatingFactors: "Some factors",
      createdBy: "joliva@cliffcomortgage.com",
      updatedBy: "joliva@cliffcomortgage.com",
      updatedDateTime: "2025-10-01T13:35:53.996000",
    },
    {
      _id: "68dbef67ba8a52da99fa5bec",
      dealId: null,
      exceptionCategory: "Borrower",
      exceptionDescription: "Exmaple example example",
      exceptionStatus: "In Review",
      riskBucket: "Borrower Profile",
      assignedTo: "cwolpert@cliffcomortgage.com",
      resolutionConditions: null,
      resolutionComments: null,
      createDateTime: null,
      dueDateTime: "2025-09-30T04:00:00",
      comments: null,
      sendEmail: true,
      sendTeamsMessage: true,
      resolutionDateTime: "2025-09-30T04:00:00",
      resolvedBy: null,
      updateDateTime: "2025-09-30T14:45:07.389000",
      associations: null,
      taskListItemId: "68d2a8dfbd67bbd3ebcf1800",
      createdBy: "joliva@cliffcomortgage.com",
      updatedBy: "dev1@cliffcomortgage.com",
      updatedDateTime: "2025-10-01T13:17:28.046000",
    },
  ],
  guidelineConforming: true,
  underwritingCheckList: {
    initialUnderwritingIsCompletedStatus: true,
    docCollectionStatus: "In Process",
    verificationOfMortgageStatus: "Received",
    backgroundReportStatus: "Requested",
    condoQuestionnaireStatus: "Received",
    creditReportStatus: "Approved",
    enviornmentalReportStatus: "Requested",
  },
  underwritingNotes: {
    _id: "68efe16f4e79a360968c1168",
    htmlString:
      '<p>UW Note Test</p>\n<p></p>\n<p></p>\n<p>Example stuff here</p>\n<p></p>\n<p></p>\n<p>More Exmaple stuff</p>\n<p></p>\n<p></p>\n<p>List of things&nbsp;</p>\n<ul>\n<li dir = "auto"><span style="color: rgb(209,72,65);"><strong>List item one</strong></span></li>\n<li dir = "auto"><del><em>List item two</em></del></li>\n<li dir = "auto"><strong>List item three</strong></li>\n<li dir = "auto">List item four</li>\n</ul>\n<p></p>\n<p></p>\n<p>Even more stuff</p>\n',
    postedBy: "joliva@cliffcomortgage.com",
    updateDateTime: "2025-09-12T18:23:36.119000",
    editorState: {},
    plainText:
      "UW Note Test\u0001\u0001\u0001Example stuff here\u0001\u0001\u0001More Exmaple stuff\u0001\u0001\u0001List of things \u0001List item one\u0001List item two\u0001List item three\u0001List item four\u0001\u0001\u0001Even more stuff",
    blocks: [],
  },
  tags: ["dev", "dev2", "dev3", "dev4", "commercial space"],
  loanProcessor: "cwolpert@cliffcomortgage.com",
  closingProceeds: "Closing Proceeds >= $2,000 / 2% of Loan Amount",
  excel_upload_file_attributes: {
    creator: "Development User",
    created: "2025-03-14T22:22:22",
    file_name: "dc9114027b25407f89b6a7079c386c1c",
    modified: "2025-04-07T21:51:35",
    sheet_names: ["Borrowers", "Loan Details", "Subject Properties"],
    last_modified_by: "Jimmy Oliva",
  },
  createdFrom: "underwriting_ui",
  createdBy: "joliva@cliffcomortgage.com",
  totalLoanAmount: 1010000,
  totalPurchasePrice: 0,
  totalAsIsValue: 0,
  totalArv: 0,
  totalSecondaryAsIsValue: 0,
  totalSecondaryArv: 0,
  totalCostBasis: 0,
  totalAssignmentFees: 0,
  totalAnnualTaxes: 0,
  totalAnnualInsurance: 0,
  totalAnnualFloodInsurance: 0,
  totalAnnualHoaFees: 0,
  totalAnnualPropertyMgmtFees: 0,
  totalAnnualOtherExpense: 0,
  totalConstructionBudget: 0,
  baseLoanToAsIsValue: 0,
  baseLoanToCost: 0,
  baseLoanToPurchasePrice: 0,
  totalLoanToArv: 0,
  lastViewBy: "joliva@cliffcomortgage.com",
  updateDatetime: "2025-10-15T18:01:19.374000",
  updateBy: "joliva@cliffcomortgage.com",
  referringPartner: "Referrer test",
  credit_authorizations: ["686434904cc018976f6111ef"],
  enhancedComments: [
    {
      commentCategory: null,
      commentCategoryObjectId: null,
      commentType: null,
      htmlString: "<p>Parse this please in the circled area</p>\n",
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-09-12T18:24:38.234000",
      mentions: [],
      dealId: null,
      commentObjects: null,
      borrowers: [],
      subjectProperties: [],
      documents: [],
      uploadMetadata: [
        {
          id: "cc05a3b9-1a44-4fef-9566-4993817cfb12",
          name: "image.png",
          file_display_name: "image.png",
        },
      ],
      submittedBy: "joliva@cliffcomortgage.com",
      _id: "68c465667fe4d088446b64c5",
    },
    {
      commentCategory: null,
      commentCategoryObjectId: null,
      commentType: null,
      htmlString: "<p>is this name correct</p>\n",
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-09-12T16:53:55.974000",
      mentions: [],
      dealId: null,
      commentObjects: null,
      borrowers: [],
      subjectProperties: [],
      documents: [],
      uploadMetadata: [
        {
          id: "4eb99b20-97ba-46f1-9377-014189df0307",
          name: "image.png",
          file_display_name: "image.png",
        },
      ],
      submittedBy: "joliva@cliffcomortgage.com",
      _id: "68c450237fe4d088446b639c",
    },
    {
      commentCategory: null,
      commentCategoryObjectId: null,
      commentType: null,
      htmlString: "<p>Copy and paste image example</p>\n",
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-09-12T15:02:53.590000",
      mentions: [],
      dealId: null,
      commentObjects: null,
      borrowers: [],
      subjectProperties: [],
      documents: ["68a6253f982207f5ea3d8097"],
      uploadMetadata: [
        {
          id: "b006d7f0-5727-458a-ae63-ca0c84b3d3ed",
          name: "image.png",
          file_display_name: "image.png",
        },
      ],
      submittedBy: "joliva@cliffcomortgage.com",
      _id: "68c4361d7fe4d088446b6296",
    },
    {
      commentCategory: null,
      commentCategoryObjectId: null,
      commentType: null,
      htmlString: "<p>Comment with uploaded file</p>\n",
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-09-11T14:42:45.446000",
      mentions: [],
      dealId: null,
      commentObjects: null,
      borrowers: ["68a61f68982207f5ea3d8018"],
      subjectProperties: ["67f44f69e685b472c479f7de"],
      documents: [],
      uploadMetadata: [
        {
          id: "a6a95b45-203d-4774-a452-2f5657143c3d",
          name: "Shawn-Turner-loan-application (1).pdf",
          file_display_name: "Shawn-Turner-loan-application (1).pdf",
        },
      ],
      submittedBy: "joliva@cliffcomortgage.com",
      _id: "68c2dfe54985e61994d46ec4",
    },
    {
      commentCategory: null,
      commentCategoryObjectId: null,
      commentType: null,
      htmlString: "<p>copy paste test</p>\n",
      postedBy: "joliva@cliffcomortgage.com",
      commentDateTime: "2025-09-10T17:05:23.276000",
      mentions: [],
      dealId: null,
      commentObjects: null,
      borrowers: ["68a61f68982207f5ea3d8018"],
      subjectProperties: ["67f44f69e685b472c479f7de"],
      documents: ["6879617e311b0d44a63be7d0"],
      uploadMetadata: [
        {
          id: "b38a5819-1da2-4fb4-9a4b-bc22c0807645",
          name: "image.png",
          file_display_name: "image.png",
        },
      ],
      submittedBy: "joliva@cliffcomortgage.com",
      _id: "68c1afd34985e61994d4697a",
    },
  ],
  loanRelatedContacts: [
    {
      _id: "68cc63fe8cc193ee4bb4c37a",
      emailAddress: "jeff@appraisals.com",
      firstName: "Jeff",
      lastName: "McNeil",
      company: "Seaver Appraisals",
      phoneNumber: null,
      loanRole: "Appraiser",
      createdBy: "joliva@cliffcomortgage.com",
      updateDateTime: "2025-09-18T19:56:46.041000",
      loanId: "67f44f69e685b472c479f7dd",
      appraiserLicenseNumber: "NY-RA012345",
      contactId: "68cc63fe8cc193ee4bb4c37b",
    },
    {
      firstName: "Bob",
      lastName: "Builder",
      company: "Home Depot",
      phone: "1233456789",
      emailAddress: "bob@building.com",
      createDateTime: "2025-09-15T15:13:59.414000",
      signUpDate: "2025-09-15T15:13:59.414000",
      loanRole: "General Contractor",
      profileComplete: true,
      email_lower: "bob@building.com",
      email_domain: "building.com",
      _id: "68c84f121f809d6ec88de71b",
    },
    {
      firstName: "Jake",
      lastName: "From",
      company: "Statefarm",
      phone: "55555555555",
      emailAddress: "jakefromstatefarm@statefarm.com",
      createDateTime: "2025-09-15T15:13:59.414000",
      signUpDate: "2025-09-15T15:13:59.414000",
      loanRole: "Insurance Agent",
      profileComplete: true,
      email_lower: "jakefromstatefarm@statefarm.com",
      email_domain: "statefarm.com",
      _id: "68c82dba1f809d6ec88de4f5",
    },
  ],
  taskListAssigned: true,
  taskListAssignedDate: "2025-09-25T14:15:28.895000",
  processingTaskListId: "68d54e80486978e3e7e63933",
  query_params: {},
  _property_totals: {
    purchasePrice: 0,
    asIsValue: 0,
    arv: 0,
    secondaryAsIsValue: 0,
    secondaryArv: 0,
    costBasis: 0,
    assignmentFees: 0,
    annualTaxes: 0,
    annualInsurance: 0,
    annualFloodInsurance: 0,
    annualHoaFees: 0,
    annualPropertyMgmtFees: 0,
    annualOtherExpense: 0,
    constructionBudget: 0,
  },
  amortizingTermMonths: 0,
  firstPaymentDate: "2026-02-01T00:00:00",
  maturityDate: "2026-01-01T00:00:00",
};
